import styled, { css } from "styled-components/macro";
import { Link } from "react-router-dom";

export const Container = styled.div`
  & img {
    width: 222px;
    height: 202px;
  }
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 32px;

  width: 500px;

  background: #ffffff;
  border: 1px solid #ebedee;
  border-radius: 8px;

  margin: 60px auto;
`;
export const StyledDoThisLater = styled.p`
  &:hover {
    cursor: pointer;
  }
  text-decoration: none;

  font-family: Poppins;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 21px;

  color: #575e68;
`;

export const IntContainer = styled(Container)`
  align-items: start;
  padding: 64px;
  width: 711px;
  form {
    font-size: 16px;
    line-height: 24px;
    color: #575e68;
    margin: 10px 0px;
    text-align: left;
  }
`;

export const StyledVideoContainer = styled.div`
  margin: auto;
  width: 100%;
`;
export const StyledVideo = styled.video`
  width: 100%;
  margin: auto;
`;
export const StyledGoBack = styled.div`
  &:hover {
    cursor: pointer;
  }
  display: flex;
  align-items: center;
  color: #575e68;
  opacity: 0.5;
  font-size: 16px;
  line-height: 22px;

  & img {
    width: 22px;
    height: 22px;
    margin: 8px;
    color: #575e68;
    opacity: 1;
  }
`;

export const Title = styled.h3`
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: 48px;

  color: #575e68;

  margin: 16px 0;
`;
export const Code = styled.code`
  width: 100%;
  white-space: pre-wrap;
  font-size: 10px;
  text-align: left;

  padding: 12px 30px;
  background: #f4f6f8;
  border: 1px solid #dddddd;
  border-radius: 4px;
`;

export const Button = styled.button`
  &:hover {
    cursor: pointer;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
  padding: 8px 12px;
  background: #6270c6;
  opacity: ${(props) => (props.disabled ? 0.2 : 1)};

  border: 1px solid #939dd6;
  border-radius: 4px;
  margin: 0 16px;

  color: #fcfcfd;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 18px;
  width: 120px;
`;
export const StyledPlatformsIntContainer = styled(IntContainer)`
  max-width: 530px;
  text-align: left;
`;

export const StyledPlatformsSubtitle = styled.p`
  font-weight: normal;
  font-size: 16px;
  line-height: 24px;

  color: #575e68;
`;

export const StyledPlatformsList = styled.ul`
  list-style: none;

  display: flex;
  flex-direction: column;

  width: 100%;

  margin: 16px 0;

  li {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    align-self: stretch;
    margin: 8px 0;
  }
`;

export const StyledPlatformLabel = styled.p`
  font-size: 16px;
  line-height: 100%;
  color: #575e68;
`;

export const StyledToggleButton = styled(Button)`
  padding: 6px 8px;
  margin: 0;
  width: 40px;
  border: 1px solid rgb(87, 94, 104, 0.8);
  overflow: hidden;
  \
`;

export const StyledToggleButtonLeft = styled(StyledToggleButton)`
  border-radius: 4px 0 0 4px;
  border-right: none;
  ${(props) =>
    props.value
      ? css`
          background: #008060;
          &:hover {
            opacity: 0.9;
          }
        `
      : css`
          color: #575e68;
          background: #ffffff;
          &:hover {
            background: rgb(87, 94, 104, 0.1);
          }
        `}
`;
export const StyledToggleButtonRight = styled(StyledToggleButton)`
  border-radius: 0 4px 4px 0;
  border-left: none;
  ${(props) =>
    props.value
      ? css`
          background: rgb(87, 94, 104, 0.8);
          &:hover {
            opacity: 0.9;
          }
        `
      : css`
          color: #575e68;
          background: #ffffff;
          &:hover {
            background: rgb(87, 94, 104, 0.1);
          }
        `}
`;

export const Button3 = styled.button`
  margin: 0;
  &:hover {
    text-decoration: none;
    cursor: pointer;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
  background: #6270c6;
  padding: 10px 21px;
  border: 1px solid #939dd6;
  border-radius: 4px;

  color: #fcfcfd;
  font-style: normal;

  font-weight: 600;
  font-size: 16px;
  line-height: 100%;
`;

export const Button2 = styled(Button)`
  &:hover {
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  }
  padding: 10px 21px;
  margin: 16px 0 0 0;
  font-size: 16px;
  opacity: ${(props) => (props.disabled ? 0.2 : 1)};
`;

export const Checklist = styled.ul`
  list-style: none;

  display: flex;
  flex-direction: column;
  align-items: start;
  ${"" /* width: 436px; */}

  margin: 32px auto;

  li,
  .tooltip {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 0px;
    align-self: stretch;
    margin: 8px 0;
  }
  .tooltip {
    width: 100%;
  }
`;

export const StyledListItem = styled.div`
  display: inline-block;
  display: flex;
  align-items: center;
  & img {
    width: 18px;
    height: 18px;
  }
`;

export const StyledLabel = styled.span`
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 100%;
  color: #575e68;
  opacity: ${(props) => (props.checked ? 0.5 : 1)};
  margin-left: 16px;
  span {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const StyledP = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 25px;
  text-align: left;
  color: #575e68;

  margin-bottom: 16px;

  & span {
    font-weight: 600;
  }
`;
export const StyledSubTitle = styled.h4`
  font-weight: 600;
  font-size: 24px;
  line-height: 36px;
  color: #575e68;
  margin: 16px 0;
`;

export const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0px;
  width: 100%;
  label {
    font-size: 14px;
    line-height: 21px;
    color: #575e68;
    padding-left: 16px;
    margin-bottom: 5px;
    span {
      color: #c64242;
    }
  }
  select {
    background: #f4f6f8;
    border: 1px solid #dddddd;
    border-radius: 4px;
    padding: 12px 16px;
    margin-bottom: 16px;
    width: 100%;
    ${"" /* appearance: none; */}
    option {
      font-size: 16px;
      line-height: 100%;
      color: #111111;
    }
  }
`;
// export const StyledLabel = styled.label``;
